/** A typed failure from the auth adapter; `code` is stable, `message` is for people. */
export class AuthFlowError extends Error {
    code;
    reason;
    name = 'AuthFlowError';
    constructor(code, message, reason) {
        super(message);
        this.code = code;
        this.reason = reason;
    }
}
//# sourceMappingURL=types.js.map